/**
 * Plays a pleasant three-note restaurant bell chime (C–E–G major chord)
 * using the Web Audio API. Works in all modern browsers without any deps.
 * Silently does nothing if AudioContext is unavailable.
 */
export function playOrderNotification(): void {
  try {
    const ctx = new AudioContext();

    const playBell = (freq: number, startTime: number): void => {
      // Fundamental tone
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, startTime);
      gain.gain.setValueAtTime(0.45, startTime);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + 1.0);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startTime);
      osc.stop(startTime + 1.0);

      // Bell harmonic overtone (2.76× gives a metallic bell quality)
      const osc2 = ctx.createOscillator();
      const gain2 = ctx.createGain();
      osc2.type = 'sine';
      osc2.frequency.setValueAtTime(freq * 2.76, startTime);
      gain2.gain.setValueAtTime(0.15, startTime);
      gain2.gain.exponentialRampToValueAtTime(0.001, startTime + 0.4);
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.start(startTime);
      osc2.stop(startTime + 0.4);
    };

    // C5 → E5 → G5  (ascending major chord arpeggio)
    const t = ctx.currentTime;
    playBell(523.25, t);        // C5
    playBell(659.25, t + 0.18); // E5
    playBell(783.99, t + 0.36); // G5

    // Free the AudioContext once chime finishes
    setTimeout(() => void ctx.close(), 3000);
  } catch {
    // AudioContext blocked (e.g. no user gesture yet) — fail silently
  }
}
